import FloodgateStorageProvider from ".././FloodgateCore/FloodgateStorageProvider";
import { FloodgateStorageProviderFileType } from "@ms-ofb/floodgate-shared-typings";

export let featureGateOverrides: Record<string, any> = null;

// Feature gate overrides are stored in cache as a JSON string unser the key "obf-FeatureGateOverrides"
// These values override feature gate values from host
export function readFeatureGateOverridesFromCache(featureGateName: string): string {
    if (!featureGateOverrides) {
        const overrides = FloodgateStorageProvider.safeReadObject(FloodgateStorageProviderFileType.FeatureGateOverrides);
        featureGateOverrides = overrides || {};
    }
    return featureGateName && featureGateOverrides?.[featureGateName];
}

export function clearFeatureGateOverridesCache(): void {
    featureGateOverrides = null;
}